import { queryOptions, mutationOptions } from "@tanstack/react-query";
import {
  fetchDashboardModuleConfiguration,
  updateDashboardModuleConfiguration,
} from "src/Pages/Company/Dashboard/services/api/api";
import { DashboardModuleConfigurationPayload } from "src/Pages/Company/Dashboard/services/api/api.models";

const GlobalKeys = {
  all: () => ["dashboard"],
};

const DEFAULT_STALE_TIME = 5 * 60 * 1000;

const DashboardQueries = {
  getDashboardModuleConfiguration: {
    all: () => [...GlobalKeys.all(), "getDashboardModuleConfiguration"],
    byCompanyId: (enabled: boolean = true, companyId: string) =>
      queryOptions({
        queryKey: [
          ...DashboardQueries.getDashboardModuleConfiguration.all(),
          companyId,
        ],
        queryFn: () => fetchDashboardModuleConfiguration(companyId),
        enabled,
        staleTime: DEFAULT_STALE_TIME,
      }),
  },
  updateDashboardModuleConfiguration: (
    companyId: string,
    payload: DashboardModuleConfigurationPayload
  ) =>
    mutationOptions({
      mutationFn: () =>
        updateDashboardModuleConfiguration({ companyId, payload }),
    }),
};

export default DashboardQueries;
